import React, { useState } from 'react';

import { PlaceholderOverrideDispatchContext } from './PlaceholderOverrideDispatchContext';
import { PlaceholderOverrideValueContext } from './PlaceholderOverrideValueContext';

export const ChatInputPlaceholderOverrideProvider = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	const [placeholderOverride, setChatInputPlaceholderOverride] = useState<string | undefined>();

	return (
		<PlaceholderOverrideDispatchContext.Provider value={setChatInputPlaceholderOverride}>
			<PlaceholderOverrideValueContext.Provider value={placeholderOverride}>
				{children}
			</PlaceholderOverrideValueContext.Provider>
		</PlaceholderOverrideDispatchContext.Provider>
	);
};
